import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import 'armxlib/style.css'
import './app/app.css'
import { App } from './app/App'
import { initTelemetry } from './lib/telemetry'

void initTelemetry()

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
